import { Component, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface UsersData {
  name: string;
  id: number;
}

@Component({
  selector: 'app-details-record',
  templateUrl: './details-record.component.html',
  styleUrls: ['./details-record.component.css']
})
export class DetailsRecordComponent {

  action: string;
  applicant: any;
  panelOpenState = false;
  sectionalItemRequestList :any = [];

  constructor(
    public dialogRef: MatDialogRef<DetailsRecordComponent>,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: UsersData) {

    this.applicant = { ...data };
    this.sectionalItemRequestList = this.applicant.sectionalItemRequestList

   

  
  }

  closeDialog() {
    this.dialogRef.close({ event: 'Cancel' });
  }
}
